<template>
    <div class="outline-popup" @click.self="closePopup">
        <div class="right-left">
            <div class="right-left-header">
                <img class="leftimg" @click="BackPopupList" src="../../assets/homeback/back.png" alt="">
                <img class="rightimg" @click="closePopup" src="../../assets/homeback/closePopup.png" alt="">
            </div>

            <!-- 气感设备  || 烟感设备-->
            <div class="right-left-cont"
                v-if="deviceInfo.DeviceId == QiGanDeviceId || deviceInfo.DeviceId == YanGanDeviceId">
                <div class="right-left-cont-img">
                    <div class="right-left-cont-img-title">
                        <div><img style="width:20px;height: 20px;" src="../../assets/homeback/text_box_left1.png"><span>{{ deviceInfo.UserDeviceName }}</span></div>
                        <div><img style="width:20px;height: 20px;" src="../../assets/homeback/text_box_left2.png"><span>{{ deviceInfo.DeviceCode }}</span></div>
                    </div>
                    <img v-if="deviceInfo.DeviceId == YanGanDeviceId" src="../../assets/homeback/yanganleft.gif">
                    <img v-else src="../../assets/homeback/qiganleft.gif">
                </div>
                <div class="right-left-cont-qigan">
                    <div class="right-left-cont-qigan-line">
                        <div>
                            <img class="lineimg" src="../../assets/homeback/bg_small.png">
                        </div>
                        <span>{{ $t('smartCity.HomeBakDeviceDetail.479422-0') }}</span>
                    </div>
                    <div class="right-left-cont-qigan-chart">
                        <dv-capsule-chart v-if="showConfig" :config="config" style="width: 100%;"
                            :style="{ height: (CanvasHeight == 1 ? '200px' : CanvasHeight + 'px') }" />
                    </div>
                </div>
            </div>
            <!-- 微断设备 -->
            <div class="right-left-cont" v-if="deviceInfo.DeviceId == WeiDuanDeviceId">
                <div class="right-left-cont-img">
                    <div class="right-left-cont-img-title">
                        <div><img style="width:20px;height: 20px;" src="../../assets/homeback/text_box_left1.png"><span>{{ deviceInfo.UserDeviceName }}</span></div>
                        <div><img style="width:20px;height: 20px;" src="../../assets/homeback/text_box_left2.png"><span>{{ deviceInfo.DeviceCode }}</span></div>
                    </div>
                    <img src="../../assets/homeback/weiduanleft.gif">
                </div>
                <div class="right-left-cont-right">
                    <div class="right-left-cont-qigan-line" style="margin-bottom: 0;">
                        <div>
                            <img class="lineimg" src="../../assets/homeback/bg_small.png">
                        </div>
                        <span>{{ $t('smartCity.HomeBakDeviceDetail.479422-1') }}</span>
                    </div>

                    <div class="right-left-cont-right-top">
                        <div id="newChart6" style="height: 96%; width: 20%;"></div>
                        <div id="newChart7" style="height: 96%; width: 20%;"></div>
                        <div id="newChart8" style="height: 96%; width: 20%;"></div>
                        <div id="newChart9" style="height: 96%; width: 20%;"></div>
                        <div id="newChart10" style="height: 96%; width: 20%;"></div>
                    </div>
                    <div class="right-left-cont-qigan-line">
                        <div>
                            <img class="lineimg" src="../../assets/homeback/bg_small.png">
                        </div>
                        <span>{{ $t('smartCity.HomeBakDeviceDetail.479422-2') }}</span>
                    </div>
                    <div class="right-left-cont-right-bottom">
                        <div id="newChart11" style="height: 98%; width: 100%;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from "echarts";
import Cookies from "js-cookie";
import api from "../../api/request.js";
export default {
    props: {
        Popupdetail: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    watch: {
        Popupdetail: {
            handler(newVal, oldVal) {
                this.deviceInfo = newVal
                console.log('ddd', newVal)
            },
            immediate: true,
        }

    },
    data() {
        return {
            config: {
                data: [
                    {
                        name: this.$t('smartCity.HomeBakDeviceDetail.479422-3'),
                        value: 167
                    },
                    {
                        name: this.$t('smartCity.HomeBakDeviceDetail.479422-4'),
                        value: 67
                    }
                ],
                colors: ['#e44637', '#18e8ca'],
                showValue: false,
            },
            deviceInfo: {},
            list1: {},
            list1: {},
            list1: {},
            list1: {},
            list1: {},
            showConfig: false,
            timeValue: '2023-07-12',
            CanvasHeight: 1,
            YanGanDeviceId: '4782d02c-0075-4105-9729-aa1b65bb250a',
            QiGanDeviceId: '88f5c429-49b6-4a9f-a908-b2ee9c8cb857',
            WeiDuanDeviceId: '6ee95d23-a802-4bd8-b823-19c0944ac5ab',
        };
    },
    mounted() {
        this.DeviceParameterLook()
        this.getDate()
    },
    methods: {
        getDate() {
            let date = new Date()
            let Y = date.getFullYear()
            let M = date.getMonth() + 1
            let D = date.getDate()
            this.timeValue = Y + '-' + M + '-' + D;
        },
        closePopup() {
            this.$emit("closePopup", false)
        },
        BackPopupList() {
            this.$emit("closePopup1", false)

        },
        DeviceParameterLook() {
            let _this = this;
            api({
                method: 'post',
                url: 'api/YhjDevice/DeviceParameterLook',
                data: {
                    deviceCode: this.deviceInfo.DeviceCode
                },
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    "Authorization": Cookies.get('Token')
                }
            }, 'yhj').then(function (res) {
                if (res.Success) {
                    let DataList = res.Data
                    if (_this.deviceInfo.DeviceId == '6ee95d23-a802-4bd8-b823-19c0944ac5ab') {
                        let list1 = {}
                        let list2 = {}
                        let list3 = {}
                        let list4 = {}
                        let list5 = {}
                        DataList.forEach((item, index) => {
                            let list = {
                                name: '',
                                value: '',
                                unit: ''
                            }
                            if (item.ParamName == _this.$t('smartCity.HomeBakDeviceDetail.479422-5')) {
                                list.name = item.ParamName
                                list.value = item.ParamValue
                                list.unit = item.ParamUnit
                                list1 = list
                            }
                            if (item.ParamName == _this.$t('smartCity.HomeBakDeviceDetail.479422-6')) {
                                list.name = item.ParamName
                                list.value = item.ParamValue
                                list.unit = item.ParamUnit
                                list2 = list
                            }
                            if (item.ParamName == _this.$t('smartCity.HomeBakDeviceDetail.479422-7')) {
                                list.name = item.ParamName
                                list.value = item.ParamValue
                                list.unit = item.ParamUnit
                                list3 = list
                            }
                            if (item.ParamName == _this.$t('smartCity.HomeBakDeviceDetail.479422-8')) {
                                list.name = item.ParamName
                                list.value = item.ParamValue
                                list.unit = item.ParamUnit
                                list4 = list
                            }
                            if (item.ParamName == _this.$t('smartCity.HomeBakDeviceDetail.479422-9')) {
                                list.name = item.ParamName
                                list.value = item.ParamValue
                                list.unit = item.ParamUnit
                                list5 = list
                            }
                        })
                        _this.list1 = list1
                        _this.list2 = list2
                        _this.list3 = list3
                        _this.list4 = list4
                        _this.list5 = list5
                        _this.drawNewChart6()
                        _this.GetNnegHaoTongJiByDate()
                    }
                    if (_this.deviceInfo.DeviceId == '88f5c429-49b6-4a9f-a908-b2ee9c8cb857') {
                        let Datas = []
                        api({
                            method: 'get',
                            url: `/api/YhjDevice/GetYiCangTongJiAbType`,
                            params: {
                                deviceCode: _this.deviceInfo.DeviceCode,
                                type: 'yue',
                            },
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                                "Authorization": Cookies.get('Token')
                            }
                        }, 'yhj').then(function (res) {
                            Datas.push({
                                name: _this.$t('smartCity.HomeBakDeviceDetail.479422-10'),
                                value: res.TotalCount
                            })
                            api({
                                method: 'get',
                                url: `/api/YhjDevice/GetQtcgqTtItemList`,
                                params: {
                                    deviceCode: _this.deviceInfo.DeviceCode,
                                },
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                                    "Authorization": Cookies.get('Token')
                                }
                            }, 'yhj').then(function (res) {
                                if (res.Data.length > 0) {
                                    res.Data.forEach((item) => {
                                        let str = item.DangQianNdz
                                        let val = str.substring(0, str.indexOf('%'))
                                        Datas.push({
                                            name: item.TanTouName,
                                            value: val
                                        })
                                    })
                                    _this.CanvasHeight = res.Data.length * 50
                                } else {
                                    Datas.push({
                                        name: _this.$t('smartCity.HomeBakDeviceDetail.479422-11'),
                                        value: 0
                                    })
                                }
                                let config = _this.config
                                config.data = Datas
                                _this.showConfig = true

                            })



                        })

                    }
                }
            }).catch(function (err) {
                _this.$Message['error']({
                    background: true,
                    content: _this.$t('smartCity.HomeBakDeviceDetail.479422-12')
                });
            });
        },



        // 能耗分时统计axios
        GetNnegHaoTongJiByDate() {
            let _this = this;
            let dt = '';
            if (_this.type == 'ri') {
                dt = _this.getDate()
            }
            const haotongjiby = new Promise((resolve, reject) => {
                api({
                    //这里是你自己的请求方式、url和data参数
                    method: 'get',
                    url: `api/YhjStatic/GetNnegHaoTongJiByDate?deviceCode=${_this.deviceInfo.DeviceCode}&dt=` + dt,
                    data: {},

                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        "Authorization": Cookies.get('Token')
                    }
                }, 'yhj').then(function (res) {
                    if (res.Success) {
                        let TongJiByShowHour = [],
                            TongJiByEtotal = [];
                        res.Data.forEach((item, index) => {
                            TongJiByShowHour.push(item.ShowHour + ':00');
                            TongJiByEtotal.push(item.Etotal);
                        })
                        _this.TongJiByShowHour = TongJiByShowHour;
                        _this.TongJiByEtotal = TongJiByEtotal;

                        // _this.$nextTick(() => {
                        //     let myChart = echarts.init(document.getElementById('initTimeEcharts'));
                        //     myChart.dispose();
                        //     _this.initTimeEcharts(TongJiByShowHour, TongJiByEtotal);
                        // });
                        _this.initTimeEcharts(TongJiByShowHour, TongJiByEtotal)

                    } else {
                        _this.$Message['error']({
                            background: true,
                            content: res.Message
                        });
                    }
                });
            })
            return haotongjiby;
        },

        // 时分比
        initTimeEcharts(showHour, etotal) {
            let _this = this;
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(document.getElementById('newChart11'))
            // 绘制图表
            myChart.setOption({
                color: ['#ffed16', '#19CA88', '#858FF8', '#FD9133', '#F6D10E', '#2E8CFF', '#F6580E'],
                tooltip: {
                    trigger: 'axis',
                },
                grid: {
                    left: '2%',
                    top: '5%',
                    right: '3%',
                    bottom: '5%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: false,
                    data: showHour,
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#ccc',
                            fontSize: 10
                        },
                    },
                    axisTick: {
                        show: false
                    },
                }],
                yAxis: [{
                    type: 'value',
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#ccc',
                            fontSize: 10
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            color: "rgba(255,255,255,0.2)"
                        }
                    },
                    axisTick: {
                        show: false
                    },
                }],
                series: [{
                    name: _this.$t('smartCity.HomeBakDeviceDetail.479422-13'),
                    type: 'line',
                    smooth: true,
                    stack: _this.$t('smartCity.HomeBakDeviceDetail.479422-14'),
                    areaStyle: {},
                    data: etotal,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(255, 237, 22,0.3)'
                            }, {
                                offset: 0.5,
                                color: 'rgba(255, 237, 22,0.1)'
                            }, {
                                offset: 1,
                                color: 'rgba(255, 237, 22,0.0)'
                            }]),
                            lineStyle: {
                                color: 'rgba(255, 237, 22,1)'
                            }
                        },
                        emphasis: {
                            color: 'rgba(255, 237, 22,1)'
                        }
                    },

                }]
            });
            window.addEventListener('resize', function () {
                myChart.resize()
            })
        },

        //微断设备环形图
        drawNewChart6() {
            let _this = this;
            let myChart1 = echarts.init(document.getElementById('newChart6'))
            let myChart2 = echarts.init(document.getElementById('newChart7'))
            let myChart3 = echarts.init(document.getElementById('newChart8'))
            let myChart4 = echarts.init(document.getElementById('newChart9'))
            let myChart5 = echarts.init(document.getElementById('newChart10'))
            let value = 40;
            let total = 100
            let percentage = (((value / total).toFixed(2)) * 100) + '%';
            let text = _this.$t('smartCity.HomeBakDeviceDetail.479422-15');
            let dataValue = value.toString();
            let list1 = _this.list1
            let list2 = _this.list2
            let list3 = _this.list3
            let list4 = _this.list4
            let list5 = _this.list5
            let title1 = {
                text: '{a|' + list1.value + '}\n{b|' + list1.unit + '}',
                x: 'center',
                y: 'center',
                textStyle: {
                    rich: {
                        a: {
                            fontSize: 16,
                            color: '#ffffff',
                            fontWeight: 'bold',
                            lineHeight: 24
                        },
                        b: {
                            fontSize: 10,
                            color: '#ffffff',
                            fontWeight: 'normal'
                        }
                    }
                }
            };
            let title2 = {
                text: '{a|' + list2.value + '}\n{b|' + list2.unit + '}',
                x: 'center',
                y: 'center',
                textStyle: {
                    rich: {
                        a: {
                            fontSize: 16,
                            color: '#ffffff',
                            fontWeight: 'bold',
                            lineHeight: 24
                        },
                        b: {
                            fontSize: 10,
                            color: '#ffffff',
                            fontWeight: 'normal'
                        }
                    }
                }
            };
            let title3 = {
                text: '{a|' + list3.value + '}\n{b|' + list3.unit + '}',
                x: 'center',
                y: 'center',
                textStyle: {
                    rich: {
                        a: {
                            fontSize: 16,
                            color: '#ffffff',
                            fontWeight: 'bold',
                            lineHeight: 24
                        },
                        b: {
                            fontSize: 10,
                            color: '#ffffff',
                            fontWeight: 'normal'
                        }
                    }
                }
            };
            let title4 = {
                text: '{a|' + list4.value + '}\n{b|' + list4.unit + '}',
                x: 'center',
                y: 'center',
                textStyle: {
                    rich: {
                        a: {
                            fontSize: 16,
                            color: '#ffffff',
                            fontWeight: 'bold',
                            lineHeight: 24
                        },
                        b: {
                            fontSize: 10,
                            color: '#ffffff',
                            fontWeight: 'normal'
                        }
                    }
                }
            };
            let title5 = {
                text: '{a|' + list5.value + '}\n{b|' + list5.unit + '}',
                x: 'center',
                y: 'center',
                textStyle: {
                    rich: {
                        a: {
                            fontSize: 16,
                            color: '#ffffff',
                            fontWeight: 'bold',
                            lineHeight: 24
                        },
                        b: {
                            fontSize: 10,
                            color: '#ffffff',
                            fontWeight: 'normal'
                        }
                    }
                }
            };
            let series = [
                //内环
                {
                    name: _this.$t('smartCity.HomeBakDeviceDetail.479422-16'),
                    type: 'pie',
                    silent: true,
                    clockwise: true,
                    radius: ['40%', '41%'],
                    label: {
                        show: false,
                    },
                    labelLine: {
                        show: false
                    },
                    itemStyle: {
                        color: 'rgba(255,255,255,.5)',
                    },
                    data: [0]
                },
                //外环
                {
                    name: '',
                    type: 'pie',
                    radius: ['46%', '55%'],
                    silent: true,
                    clockwise: true,
                    startAngle: 90,
                    label: {
                        show: false,
                    },
                    data: [
                        {
                            value: value,
                            itemStyle: {
                                normal: {
                                    //外环发光
                                    shadowBlur: 10,
                                    shadowColor: '#fff',
                                    // color: '#fbec1b'
                                    color: '#1ce1c7'
                                }
                            }
                        },
                        {
                            value: 100 - value,
                            label: {
                                normal: {
                                    show: false
                                }
                            },
                            itemStyle: {
                                normal: {
                                    shadowBlur: 10,
                                    shadowColor: '#fff',
                                    color: "rgba(255,255,255,.5)"
                                }
                            }
                        }
                    ]
                },
            ]
            let graphic1 = [{
                type: 'text',
                left: 'center', // 文字水平居中对齐
                bottom: 5, // 距离底部的距离
                style: {
                    fill: '#fff', // 文字颜色
                    text: list1.name, // 要显示的文字内容
                    font: '14px Arial' // 文字字体和大小
                }
            }]
            let graphic2 = [{
                type: 'text',
                left: 'center', // 文字水平居中对齐
                bottom: 5, // 距离底部的距离
                style: {
                    fill: '#fff', // 文字颜色
                    text: list2.name, // 要显示的文字内容
                    font: '14px Arial' // 文字字体和大小
                }
            }]
            let graphic3 = [{
                type: 'text',
                left: 'center', // 文字水平居中对齐
                bottom: 5, // 距离底部的距离
                style: {
                    fill: '#fff', // 文字颜色
                    text: list3.name, // 要显示的文字内容
                    font: '14px Arial' // 文字字体和大小
                }
            }]
            let graphic4 = [{
                type: 'text',
                left: 'center', // 文字水平居中对齐
                bottom: 5, // 距离底部的距离
                style: {
                    fill: '#fff', // 文字颜色
                    text: list4.name, // 要显示的文字内容
                    font: '14px Arial' // 文字字体和大小
                }
            }]
            let graphic5 = [{
                type: 'text',
                left: 'center', // 文字水平居中对齐
                bottom: 5, // 距离底部的距离
                style: {
                    fill: '#fff', // 文字颜色
                    text: list5.name, // 要显示的文字内容
                    font: '14px Arial' // 文字字体和大小
                }
            }]
            let option1 = {
                graphic: graphic1,
                title: title1,
                series: series,
            }
            let option2 = {
                graphic: graphic2,
                title: title2,
                series: series,
            }
            let option3 = {
                graphic: graphic3,
                title: title3,
                series: series,
            }
            let option4 = {
                graphic: graphic4,
                title: title4,
                series: series,
            }
            let option5 = {
                graphic: graphic5,
                title: title5,
                series: series,
            }
            myChart1.setOption(option1, true);
            myChart2.setOption(option2, true);
            myChart3.setOption(option3, true);
            myChart4.setOption(option4, true);
            myChart5.setOption(option5, true);
        },
        //微断设备折线图
        drawNewChart7() {
            let xData = [1, 2, 3, 4, 5, 6]
            let yData = [1, 2, 3, 4, 5, 6]
            let _this = this;
            let myChart = echarts.init(document.getElementById('newChart11'))
            myChart.setOption({
                tooltip: {
                    trigger: "axis",
                    backgroundColor: "rgba(0,0,0,.6)",
                    borderColor: "rgba(147, 235, 248, .8)",
                    textStyle: {
                        color: "#FFF",
                    },
                },
                grid: {
                    left: "5%",
                    right: "5%",
                    bottom: "5%",
                    top: "20%",
                    containLabel: true,
                },

                xAxis: {
                    name: _this.$t('smartCity.HomeBakDeviceDetail.479422-17'),
                    type: "category",
                    axisLine: {
                        lineStyle: {
                            color: "#BDD8FB",
                            fontSize: 12,
                        },
                    },
                    axisLabel: {
                        // interval:0,
                        color: "#BDD8FB",
                        fontSize: 12,
                    },
                    axisTick: {
                        show: false,
                    },
                    data: xData,
                },
                yAxis: {
                    name: _this.$t('smartCity.HomeBakDeviceDetail.479422-18'),
                    type: "value",
                    min: 0,
                    minInterval: 1,
                    nameTextStyle: {
                        fontSize: 12,
                        color: "#BDD8FB",
                        align: "center",
                    },
                    splitLine: {
                        lineStyle: {
                            color: "rgba(255, 255, 255, 0.15)",
                            // type: 'dashed', // dotted 虚线
                        },
                    },
                    splitArea: { show: false },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#BDD8FB'
                        }
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        fontSize: 12,
                        fontFamily: "Bebas",
                        color: "#BDD8FB",
                    },
                },
                series: [
                    {
                        type: "line",
                        symbol: "none",
                        // showSymbol: false,
                        smooth: true, // 是否曲线
                        name: _this.$t('smartCity.HomeBakDeviceDetail.479422-18'),
                        data: yData, // 纵坐标数据
                        lineStyle: {
                            color: '#dfda26',
                            width: 2
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,  //右
                                y: 0,  //下
                                x2: 0,  //左
                                y2: 1,  //上
                                colorStops: [
                                    {
                                        offset: 0.1,
                                        color: '#d2d02b' // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: 'transparent' // 100% 处的颜色
                                    }
                                ]
                            },
                        },
                    }
                ],
            });
            window.addEventListener('resize', function () {
                if (_this.homeType == 'newHome' && _this.showArea) {
                    myChart.resize();
                }
            })
        },
    }
}
</script>


<style scoped="scoped" lang="scss">
@import "./big_screen_default.scss";
@import "./big_screen.scss";
@import "./home_back1.scss";

.ifram_bgclo {
    background-color: #fff;
    width: 100vw;
    height: 100vh;
}

.right-left {
    position: relative;

    &-header {
        width: 100%;
        height: 4vh;
        position: relative;

        >img {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 26px;
            height: 26px;
            opacity: .7;
        }

        .leftimg {
            left: 0;
            cursor: pointer;
        }

        .rightimg {
            right: 0;
            cursor: pointer;
        }
    }

    &-cont {
        height: 80%;
        display: flex;
        justify-content: space-around;
        align-items: center;


        &-img {
            width: 33%;

            >img {
                width: 100%;
                height: auto;
                animation: tanchu1 0.5s linear infinite;
                animation-iteration-count: 1;
                @keyframes tanchu1 {
                    0% {
                        transform: scale(0);
                    }

                    100% {
                        transform: scale(100%);
                    }
                }
            }
            &-title{
                box-sizing: border-box;
                padding-left: 20px;
                font-size: 14px;
                font-weight: 500;
                display: flex;
                justify-content: space-evenly;
                animation: tanchu 0.5s linear infinite;
                animation-iteration-count: 1;
                animation-delay:0.2;
                @keyframes tanchu {
                    0% {
                        transform: scale(0);
                    }

                    100% {
                        transform: scale(100%);
                    }
                }
                >div{
                    width: 42%;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    background-image: url('../../assets/homeback/text_box.png');
                    background-size: 100% 100%;
                    white-space:nowrap;
                    padding:0 10px;
                    box-sizing: border-box;

                    >span{
                        margin-left: 8px;
                    }
                }

                >div:first-child{
                    margin-bottom: 6px;
                }
            }
        }

        &-qigan {
            width: 50%;
            height: 90%;
        }

        &-qigan-line {
            width: 100%;
            height: 10%;
            margin-bottom: 5%;
            display: flex;
            align-items: center;
            font-size: 16px;

            >div {
                width: 40px;
                height: 40px;
                background: url('../../assets/homeback/bg_big.png');
                background-repeat: no-repeat;
                background-size: cover;
                display: flex;
                justify-content: center;
                align-items: center;
                animation: rotate 6s linear infinite;

                .lineimg {
                    height: 15px;
                    width: 15px;
                }

                @keyframes rotate {
                    0% {
                        transform: rotateZ(0deg);
                    }

                    100% {
                        transform: rotateZ(360deg);
                    }
                }
            }

        }

        &-qigan-chart {
            width: 100%;
            height: 80%;
            overflow-y: scroll;
            scrollbar-width: none;
            -ms-overflow-style: none;
        }

        &-qigan-chart::-webkit-scrollbar {
            display: none;
        }

        &-right {
            width: 60%;
            height: 100%;



            &-top {
                width: 100%;
                height: 40%;
                display: flex;
                justify-content: space-evenly;
                margin-bottom: 5%;
            }

            &-bottom {
                width: 100%;
                height: 35%;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/smartCity/HomeBakDeviceDetail.vue